module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-About3.cf3312e8.webp";